import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';

@Component({
    templateUrl: './confirmation-dialog.component.html',
    selector: 'scitis-confirmation-dialog',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {

  @Input()
  title: string = '';

  @Input()
  body: string = '';

  @Input()
  okButtonText: string = '';

  @Input()
  cancelButtonText: string = '';

  @Input()
  disableOkButton: boolean = false;

  constructor(private activeModal: NgbActiveModal) {
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onOk(_$event: boolean) {
    this.activeModal.dismiss(ModalDialogDismissOption.OK);
  }

  onCancel(_$event: boolean) {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }
}
